import * as React from 'react';

function SvgDashboardViewOutline(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
      <path d="M11.49 16v2A1.5 1.5 0 1110 19.5H8a3.5 3.5 0 103.5-3.5z" />
      <path d="M3 3v26h26V3zm24 7H14V5h13zM12 5v5H5V5zM5 27V12h22v15z" />
      <path d="M17.99 16h2v7h-2zM21.99 19h2v4h-2z" />
    </svg>
  );
}

export default SvgDashboardViewOutline;
